module.exports = __webpack_public_path__ + "img/andrea_fryrear.jpeg";